import React from 'react'
import cn from 'classnames'
import { ButtonBase } from '@material-ui/core'
import { tenderSelectionIcons } from '../../utils/icons'
import { PAYMENT_TYPES_INTERNAL } from '../../utils/paymentTypes'
import { ReactComponent as RadioSelected } from '../../assets/icons/radio-selected.svg'
import { ReactComponent as RadioUnSelected } from '../../assets/icons/radio-unselected.svg'
import styles from './TenderItem.module.scss'

/**
 * Tender Item for Tender Selection with Radio Buttons and Icons
 * Custom Handlers for Click Events
 *
 * @param {*} param
 * @returns {React.Component}
 */
const TenderItem = ({ name, type, selectedType, handleOnClick }) => {
  const selected = type === selectedType || name === selectedType
  const iconName = type === PAYMENT_TYPES_INTERNAL.SAVED_CARD ? 'card' : name
  const icon = React.cloneElement(tenderSelectionIcons(iconName), { className: styles.tenderIcon })

  return (
    <div className={cn([styles.container, selected && styles.selected])}>
      <ButtonBase focusRipple onClick={handleOnClick} component="div">
        {selected ? <RadioSelected className={styles.icon} /> : <RadioUnSelected className={styles.icon} />}
        <div className={styles.label}>{name}</div>
        <div className={styles.label}>{icon}</div>
      </ButtonBase>
    </div>
  )
}

export default TenderItem
